<template>
  <header :class="'it-header-wrapper' + classComp" id="headerCdp">
    <div class="it-header-slim-wrapper unige">
      <div class="container-fluid" style="padding: 0;">
        <div class="d-flex justify-content-between align-items-center" style="height: 100%;">
          <div class="it-brand-wrapper d-flex align-items-center">
            <img src="@/assets/logo_orizzontale_WHITE.png" alt="Università di Genova Logo" class="unige-logo-header" />
          </div>
          <div class="it-header-slim-right-zone d-flex align-items-center justify-content-end" style="margin-right: 0;">



<!--            <div class="text-white btn-icon btn-full dropdown-toggle  " style="">-->
<!--              <div class="btn-group">-->
<!--                <button @click="toggleDropdown" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--                  {{currentFlag}}-->
<!--                </button>-->
<!--                <div class="dropdown-menu dropdown-menu-right" :class="{ 'show': isDropdownOpen }" style="top: 50px;">-->
<!--                  <button  @click="changeLocale('en')" class="dropdown-item" type="button">EN</button>-->
<!--                  <button @click="changeLocale('it')" class="dropdown-item" type="button">IT</button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

            <ButtonUserLogin @showProfile="showProfile"  :firstname="firstname" :lastname="lastname" @logout="userStore.logout"></ButtonUserLogin>

          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import {ref, computed, onMounted, onBeforeMount} from "vue";
  import {ButtonUserLogin} from "cdp-fe-commons-layout";
import { setLocale } from "@/i18n"; // Import the setLocale function from i18n.js
import enFlag from '@/assets/flags/en-flag.jpg';
import itFlag from '@/assets/flags/it-flag.png';
import { useServiceDetailStore } from "@/stores/service/serviceDetail";
import {useUserStore} from "@/stores/user";
import { useRouter } from 'vue-router';

const router = useRouter();

const serviceDetailStore = useServiceDetailStore();


const userref = ref<IUser>();
const firstname=ref('')
const lastname=ref('')
const userStore = useUserStore();
onBeforeMount(async () => {
 // userStore.getUser().then((userEl: IUser | undefined) => userref.value = userEl);
  const userdata = await userStore.getUser();
  if(userdata){
    userref.value = userdata;
    firstname.value=userdata.firstname
    lastname.value=userdata.lastname
  }
})

function showProfile() {
  router.push('/profilo')
}


const props = withDefaults(defineProps<{
  locked?: boolean;
}>(), { locked: false });

const emits = defineEmits<{
  (e: 'clientHeight', height: number): void;
}>();

const currentLocale = ref(localStorage.getItem("locale") || "en");
const currentFlag = computed(() => currentLocale.value === "en" ? 'EN' : 'IT');
const isDropdownOpen = ref(false);
function changeLocale(locale: string) {
  setLocale(locale);
  serviceDetailStore.setLanguage(locale)
  currentLocale.value = locale;
  localStorage.setItem("locale", locale); // Persist language choice
  toggleDropdown();
}

function toggleDropdown() {
  isDropdownOpen.value = !isDropdownOpen.value;
}

const classComp = computed(() => {
  return props.locked ? ' fixed-top' : '';
});


// Adjust Header Height
onMounted(() => {
  const el: HTMLElement | null = document.getElementById("headerCdp");
  if (el !== null) {
    emits("clientHeight", el.clientHeight);
  }
});


</script>

<style scoped>
.unige-logo-header {
  height: 50px;
  max-height: 100%;
  display: block;
}

.flag-icon {
  width: 24px;
  height: 16px;
  margin-right: 8px;
}

.it-brand-wrapper {
  display: flex;
  align-items: center;
  padding-left: 10px;
  margin-left: 0;
  flex-shrink: 1;
}

.it-header-slim-wrapper {
  background-color: #002677 !important;
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.it-header-slim-right-zone {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  flex-shrink: 1;
}

.dropdown-menu {
  min-width: 150px;
}

@media (max-width: 576px) {
  .unige-logo-header {
    height: 40px;
  }

  .it-header-slim-wrapper {
    padding: 0 10px;
  }

  .it-header-slim-right-zone {
    margin-right: 5px;
  }

  .it-header-slim-right-zone button {
    font-size: 14px;
    padding: 5px 10px;
  }
}

@media (min-width: 577px) {
  .it-header-slim-right-zone {
    margin-right: 15px;
  }

  .it-header-slim-right-zone button {
    font-size: 16px;
    padding: 8px 15px;
  }
}

@media (min-width: 1200px) {
  .it-header-slim-wrapper {
    padding: 0 25px;
  }

  .unige-logo-header {
    height: 50px;
  }

  .it-header-slim-right-zone {
    margin-right: 20px;
  }
}
</style>
